import { render } from "./p-slider.vue?vue&type=template&id=6e34bb96&scoped=true"
import script from "./p-slider.vue?vue&type=script&lang=js"
export * from "./p-slider.vue?vue&type=script&lang=js"

import "./p-slider.vue?vue&type=style&index=0&id=6e34bb96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e34bb96"]])

export default __exports__